






















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import ProductLessonScheduleItem from '@/web/components/products/ProductLessonScheduleItem.vue';
import ProductLessonScheduleModal from '@/web/components/products/ProductLessonScheduleModal.vue';

export default Vue.extend({
  name: 'ProductSchedule',
  components: { ProductLessonScheduleItem },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      teacherProduct: 'product/teacherProduct',
    }),
    isPricingTypeRecurring(): boolean {
      return this.productForm.pricing_type === 'recurring';
    },
    isEvergreenType(): boolean {
      return this.productScheduleType === 'evergreen';
    },
    productScheduleType: {
      get(): string {
        return this.productForm.product_schedule_type;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_schedule_type: value,
          product_drip_start_date: null,
          product_drip_end_date: null,
          product_available_days: null,
        });
      },
    },
    productAvailableDays: {
      get(): number {
        return this.productForm.product_available_days;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          product_available_days: value,
        });
      },
    },
    date: {
      get(): DatePicker {
        const product = this.productForm;
        return product.product_drip_end_date && product.product_drip_start_date
          ? {
              startDate: moment(product.product_drip_start_date).toDate(),
              endDate: moment(product.product_drip_end_date).toDate(),
            }
          : {
              startDate: new Date(),
              endDate: new Date(),
            };
      },
      set(value: DatePicker) {
        const startDate = value.startDate
          ? moment(value.startDate).format('yyyy-MM-DD')
          : null;
        const endDate = value.endDate
          ? moment(value.endDate).format('yyyy-MM-DD')
          : null;
        this.$store.dispatch('product/setProductForm', {
          product_drip_start_date: startDate,
          product_drip_end_date: endDate,
        });
      },
    },
    lessons(): LessonResponse {
      return this.productForm.lessons;
    },
  },
  methods: {
    showLessonScheduleModal(lesson: LessonResponse): void {
      this.$modal.show(ProductLessonScheduleModal, {
        lesson,
      });
    },
  },
});
